module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-4-photo-2-bbee047eb48a7acc1142f35e3f3fef5e.webp";